<template>
  <div id="SidebarAdmin">
    
    <nav class="navbar navbar-expand-custom navbar-mainbg fixed-top">
    
        <div class="navbar-brand navbar-logo dropdown">
          <h5  @click="logout()">Logout</h5>
        
         
          <!-- <a
            class="dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
          STAFF
            <img
              src="https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png"
              alt=""
              style="width: 43px; left: 30px"
            />
          </a>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item"  @click="logout()">logout</a>
          </div> -->
        </div>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="fas fa-bars text-white"></i>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          
          <ul class="navbar-nav ml-auto">
            <div class="hori-selector">
              <div class="left"></div>
              <div class="right"></div>
            </div>

            <li class="nav-item">
              <router-link
                to="/staff"
                class="nav-link"
                active-class="active"
                exact
              >
                <i class="fas fa-tachometer-alt fa-lg"></i> Dashboard
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                to="/neworders"
                class="nav-link icon-noti"
                active-class="active"
                exact
              >
                <i class="far fa-bell fa-lg"></i>
                <span class="icon-button__badge_myjob">
                   {{
                    orders +
                    +(orders > 1 || orders == 0 ? "0" : "")
                  }} 
                 </span
                >
                <!-- <i class="fas fa-tachometer-alt"></i>  -->
                NewOrders
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                to="/myjob"
                class="nav-link icon-noti"
                active-class="active"
                exact
              >
                <i class="fas fa-diagnoses fa-lg"></i>
                  <span class="icon-button__badge_myjob">
                    {{
                    setmyjob +
                    +(setmyjob > 1 || setmyjob === 0 ? "0" : "")
                  }} </span>
                MyJob
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                to="packing"
                class="nav-link icon-noti"
                active-class="active"
                exact
              >
                <i class="fab fa-stack-overflow fa-lg"></i>
                  <span class="icon-button__badge_myjob">
                    {{
                    setpacking +
                    +(setpacking > 1 || setpacking === 0 ? "0" : "")
                  }} 
                 </span>  Packing
                <!-- <i class="far fa-address-book"></i> -->
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                to="ready"
                class="nav-link"
                active-class="active"
                exact
              >
                <i class="fas fa-people-carry fa-lg"></i>
                <span class="icon-button__badge_myjob">
                    {{
                    setready+
                    +(setready> 1 || setready=== 0 ? "0" : "")
                  }} 
                 </span>
                 Ready
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link
                to="ordersucess"
                class="nav-link"
                active-class="active"
                exact
              >
                <i class="far fa-calendar-check fa-lg"></i> OrderSucess
              </router-link>
            </li>

            <li class="nav-item">
              <router-link
                to="history"
                class="nav-link"
                active-class="active"
                exact
              >
                <i class="fas fa-tasks fa-lg"></i> History
              </router-link>
            </li> -->
             <li class="nav-item">
              <router-link
                to="history"
                class="nav-link"
                active-class="active"
                exact
              >
                <i class="fas fa-tasks fa-lg"></i> History
              </router-link>
            </li> 
         
          <li class="nav-item">
              <router-link
                to="upload"
                class="nav-link"
                active-class="active"
                exact
              >
                <i class="fas fa-cloud-upload-alt fa-lg"></i>
                Slide
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                to="staffMeeting"
                class="nav-link"
                active-class="active"
                exact
              >
              <i class="fa-solid fa-people-roof"></i>
                Meeting Room
              </router-link>
            </li>
            <li class="nav-item">
              <a :href="'https://opac.ubru.ac.th/checkstock.html?tmp='+staff_code" class="nav-link">
                <i class="fa-solid fa-layer-group fa-lg"></i>
                  Check Stock
              </a>
              <!-- <router-link
                :to="'https://opac.ubru.ac.th/checkstock.html?tmp='+staff_code"
                class="nav-link"
                active-class="active"
                exact
              >
              
              </router-link> -->
            </li>

            <!-- <li class="nav-item">
              <router-link
                to="staff-feedback"
                class="nav-link"
                active-class="active"
                exact
              >
              <i class="fa-solid fa-people-roof"></i>
                Feed Back
              </router-link>
            </li> -->
          </ul>
        </div>
     
    </nav>
  </div>
</template>

<script>
import $ from "jquery";
// import axios from "axios";
export default {
  name: "SidebarAdmin",
  props: ['setpacking','orders','setmyjob','setready'],
  data() {
    return {
      staff_code:''
    };
  },
  mounted() {
    let auth = JSON.parse(localStorage.getItem("auth"));
   let code = auth.std_code;

   this.staff_code = window.btoa(code);
    setTimeout(()=>{
      $("iframe").remove();
    },8000);
  
    // ---------Responsive-navbar-active-animation-----------
    function test() {
      var tabsNewAnim = $("#navbarSupportedContent");
      // var selectorNewAnim = $("#navbarSupportedContent").find("li").length;
      var activeItemNewAnim = tabsNewAnim.find(".active");
      var activeWidthNewAnimHeight = activeItemNewAnim.innerHeight();
      var activeWidthNewAnimWidth = activeItemNewAnim.innerWidth();
      var itemPosNewAnimTop = activeItemNewAnim.position();
      var itemPosNewAnimLeft = activeItemNewAnim.position();
      $(".hori-selector").css({
        top: itemPosNewAnimTop.top + "px",
        left: itemPosNewAnimLeft.left + "px",
        height: activeWidthNewAnimHeight + "px",
        width: activeWidthNewAnimWidth + "px",
      });
      $("#navbarSupportedContent").on("click", "li", function () {
        $("#navbarSupportedContent ul li").removeClass("active");
        $(this).addClass("active");

        var activeWidthNewAnimHeight = $(this).innerHeight();
        var activeWidthNewAnimWidth = $(this).innerWidth();
        var itemPosNewAnimTop = $(this).position();
        var itemPosNewAnimLeft = $(this).position();
        $(".hori-selector").css({
          top: itemPosNewAnimTop.top + "px",
          left: itemPosNewAnimLeft.left + "px",
          height: activeWidthNewAnimHeight + "px",
          width: activeWidthNewAnimWidth + "px",
        });
      });
    }
    $(document).ready(function () {
      setTimeout(function () {
        test();
      });
    });

    $(window).on("resize", function () {
      setTimeout(function () {
        test();
      }, 500);
    });
    $(".navbar-toggler").click(function () {
      setTimeout(function () {
        test();
      });
    });
  },
  methods: {
     logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
     }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto");

body {
  font-family: "Roboto", sans-serif;
}
* {
  margin: 0;
  padding: 0;
}
a {
  color: rgba(70, 5, 97, 0.961);
}
a:hover {
  text-decoration: initial;
  color: rgb(90, 5, 187);
}

i {
  margin-right: 10px;
}
/*----------multi-level-accordian-menu------------*/
.icon-noti {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-button__badge {
  position: absolute;
  top: 15px;
  left: 28px;
  width: 15px;
  height: 15px;
  background: red;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px;
}

.icon-button__badge_myjob {
  position: absolute;
  top: 15px;
  left: 34px;
  width: 15px;
  height: 15px;
  background: red;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px;
}
.navbar-logo {
  padding: 10px;
  color: #fff;
}
.navbar-mainbg {
  background-color: #a077ff;
  padding: 0px;
}
#navbarSupportedContent {
  overflow: hidden;
  position: relative;
}
#navbarSupportedContent ul {
  padding: 0px;
  margin: 0px;
}
#navbarSupportedContent ul li a i {
  margin-right: 10px;
}
#navbarSupportedContent li {
  list-style-type: none;
  float: left;
}
#navbarSupportedContent ul li a {
  color: rgba(255, 255, 255, 0.632);
  text-decoration: none;
  font-size: 15px;
  display: block;
  padding: 20px 20px;
  transition-duration: 0.6s;
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  position: relative;
}
#navbarSupportedContent > ul > li > a.active {
  color: #3b076f;
  background-color: transparent;
  transition: all 0.7s;
}
#navbarSupportedContent a:not(:only-child):after {
  content: "\f105";
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 14px;
  font-family: "Font Awesome 5 Free";
  display: inline-block;
  padding-right: 3px;
  vertical-align: middle;
  font-weight: 900;
  transition: 0.5s;
}
#navbarSupportedContent .active > a:not(:only-child):after {
  transform: rotate(90deg);
}
.hori-selector {
  display: inline-block;
  position: absolute;
  height: 100%;
  top: 0px;
  left: 0px;
  /* transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55); */
  background-color: #fff;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  margin-top: 10px;
}
.hori-selector .right,
.hori-selector .left {
  position: absolute;
  width: 25px;
  height: 25px;
  background-color: #fff;
  bottom: 10px;
}
.hori-selector .right {
  right: -25px;
}
.hori-selector .left {
  left: -25px;
}
.hori-selector .right:before,
.hori-selector .left:before {
  content: "";
  position: absolute;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #a077ff;
  
}
.hori-selector .right:before {
  bottom: 0;
  right: -25px;
}
.hori-selector .left:before {
  bottom: 0;
  left: -25px;
}

@media (min-width: 992px) {
  .navbar-expand-custom {
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
  .navbar-expand-custom .navbar-nav {
    -ms-flex-direction: row;
    flex-direction: row;
  }
  .navbar-expand-custom .navbar-toggler {
    display: none;
  }
  .navbar-expand-custom .navbar-collapse {
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (max-width: 991px) {
  .icon-button__badge {
    position: absolute;
    top: 8px;
    left: 120px;
    width: 15px;
    height: 15px;
    background: red;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 12px;
  }
  .icon-button__badge_myjob {
    position: absolute;
    top: 3px;
    left: 130px;
    width: 15px;
    height: 15px;
    background: red;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 12px;
  }
  #navbarSupportedContent ul li a {
    padding: 12px 30px;
  }
  .hori-selector {
    margin-top: 0px;
    margin-left: 10px;
    border-radius: 0;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }
  .hori-selector .left,
  .hori-selector .right {
    right: 10px;
  }
  .hori-selector .left {
    top: -25px;
    left: auto;
  }
  .hori-selector .right {
    bottom: -25px;
  }
  .hori-selector .left:before {
    left: -25px;
    top: -25px;
  }
  .hori-selector .right:before {
    bottom: -25px;
    left: -25px;
  }
}

</style>